module.exports = __webpack_public_path__ + "img/aixin.904426a1.png";